export const PDP = "pdp"
export const PDP_DEATAIL = "product details"
export const NAVIGATION = "navigation"

export const CONFIGURATOR_MODAL = "configurator modal"
export const BEGIN_DESIGN = "begin your design here"
export const NEXT = "next"
export const CONVERSION = "conversion"
export const MANUAL_COLLAPSE = "manual collapse"
export const SUMMARY_TRACKING = "summary"
export const ADD_TO_CART = "add to cart"

export const COLOR_SELECTION = "color"
export const BOWL_HEIGHT_SELECTION = "bowlheight"
export const FLUSHING_TECH_SELECTION = "flushingtech"
export const HANDLE_SELECTION = "handle"
export const FLUSHING_TECHNOLOGY = "flushing technology"
export const INSTALL_ITEMS_SELECTION = "installItems"
export const BOWL_HEIGHT = "toilet height"
export const FLUSH_HANDLE = "flush location"
export const SEAT = "seat"
export const INSTALL_ITEMS = "Complete your project"
export const NO_SEAT = "No Seat"
export const NONE = "None"
export const NOT_APPLICABLE = "not applicable"
export const SWATCH_NA = "swatch_NA"
export const NOT_APPLICABLE_SRCH = "Not Applicable"
export const ITEMTYPE = "product"
export const PDPTYPE = "regular finished goods"
export const STOCK = "in stock"

export const COLOR_SECTION = "Color/Finish"
export const FLUSHING_TECH_SECTION = "Flushing Technology"
export const BOWL_HEIGHT_SECTION = "Bowl Height"
export const FLUSH_HANDLE_SECTION = "Flush Handle Placement"
export const SEAT_SECTION = "Seat"
export const INSTALL_ITEMS_SECTION = "Install Items"

export const POSITION_PDP = "pdp"
export const COMPONENT_NAME = "configurator"
export const NA = "n/a"
export const TOILETS = "toilets"
export const YES = "Yes"

export const PERCENTOFF = "percentOff|"

export const CACHET_SEAT = "cachet"

export const CROSS_UPSELL = "cross-sell + upsell"

export const SECTION_MAP = {
  [COLOR_SECTION]: COLOR_SELECTION,
  [FLUSHING_TECH_SECTION]: FLUSHING_TECHNOLOGY,
  [BOWL_HEIGHT_SECTION]: BOWL_HEIGHT,
  [FLUSH_HANDLE_SECTION]: FLUSH_HANDLE,
  [SEAT_SECTION]: SEAT,
  [INSTALL_ITEMS_SECTION]: INSTALL_ITEMS,
}

export const ACCORDION_TO_SECTION = {
  color: COLOR_SECTION,
  bowlheight: BOWL_HEIGHT_SECTION,
  flushingtech: FLUSHING_TECH_SECTION,
  handle: FLUSH_HANDLE_SECTION,
  seat: SEAT_SECTION,
  installitems: INSTALL_ITEMS_SECTION,
}

export const COLOR_SKU_DETAILS_SS = "Color.SKU.Details_ss"
export const CUSTOMER_FACING_BRAND_S = "CustomerFacingBrand_s"
export const PRODUCT_BRAND_NAME_DISPLAY_S = "ProductBrandNameDisplay_s"
export const PRODUCT_LOCAL_CATEGORY = "ProductLocalCategory_s"
export const PRODUCT_DESC_SHORT = "ProductDescriptionProductShort_s"
export const PRODUCT_CATEGORY = "Product_Category"
export const PRICE_AMT_F = "Price_Amt_f"
export const SUPER_SKU = "Super_Sku"
export const MASTER_SKU = "masterSKU_s"
export const PRODUCTIMAGES_LABEL_URL = "productImages.labelWithUrl_ss"
export const PRODUCT_WATER_SENSE = "ProductWaterSense_ss"
export const PRICE_LIST = "priceList"
export const PRICE_D = "price_d"
export const FINAL_PRICE_D = "finalPrice_d"
export const DISCOUNTED_PRICE_D = "discountedPrice_d"
export const SALE_OFFER = "saleOffer_s"
export const PRODUCT_IS_RETAIL = "ProductIsRetail"
export const COMBO_SKU_AVAILABLE = "comboSKUAvailable_b"
export const CATEGORY_S = "category1_s"
